import { useIsMutating } from '@tanstack/react-query';

/** 同じダイヤへの保存（{ id }）が走っているか。詳細を開き直しても分かるよう mutationKey で見る。保存中は名前・所属を操作不可にする */
export const useIsTimetableSaving = (timetableId: number) =>
  useIsMutating({ mutationKey: ['timetableSave'], predicate: (m) => (m.state.variables as { id?: number } | undefined)?.id === timetableId }) > 0;
